export class Prize {
    public id: string;
    public title: string;
    public description: string;
    public details?: string;
    public value: number;
    public startDate: Date;
    public endDate?: Date;
    public ordBy: number;
    public imageUrl?: string;

    constructor() {
        this.id = '';
        this.title = '';
        this.description = '';
        this.value = 0;
        this.startDate = new Date();
        this.ordBy = 0;
        this.imageUrl = '';
    }
}
